import React from "react";
import image1 from "../../assets/images/images01.webp";
import image3 from "../../assets/images/images03.webp";
import image4 from "../../assets/images/images04.webp";
import image5 from "../../assets/images/images05.webp";
import image6 from "../../assets/images/images06.webp";
import image7 from "../../assets/images/images07.webp";
import image8 from "../../assets/images/images08.webp";
import image9 from "../../assets/images/images09.webp";
import "./carouselStyle.css";

function ServicesCarousel() {
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col badgesCarousel overflow-hidden">
            <h4 className="text-center badgeHeading">Driven by Certified Profesionals</h4>
            <div className="scrollLeft">
               {[...Array(2)].map((_, i) => (
      <React.Fragment key={i}>
              <img
                src={image1}
                alt="..."
                
              />
              <img
                src={image3}
                alt="..."
              />
              <img
                src={image4}
                alt="..."
              />
              <img
                src={image5}
                alt="..."
              />
              <img
                src={image6}
                alt="..."
              />
              <img
                src={image7}
                alt="..."
              />
              <img
                src={image8}
                alt="..."
              />
              <img
                src={image9}
                alt="..."
              />
              </React.Fragment>
              ))}

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ServicesCarousel;
